module.exports = __webpack_public_path__ + "img/community-border.ed264f8e.svg";